<template lang="es">
  <div class="full-height-component-flexed">
  <!-- Estado horno:{{estado_horno}} -->
  <dialogo-pin
    :activar="dialogo_parar"
    titulo="FINALIZAR TRATAMIENTO"
    mensaje="Introduce la contraseña para parar el horno y finalizar el tratamiento"
    clave="clave_parada"
    @confirmado="parar()"
    @cancelar="dialogo_parar = false">
  </dialogo-pin>
  <dialogo-confirmacion 
    :activar="dialogo_arrancar" 
    tituloDialogo="INICIAR TRATAMIENTO" 
    toolbarColor="green" 
    buttonColor="green"
    tipo="arrancar"
    textoDialogo='Seleccione el tipo de arranque:'
    nombreMetodo="arrancar"
    @arrancar="enMarcha" 
    @cancelar="dialogo_arrancar = false">
  </dialogo-confirmacion>
  <v-container :class="clase_pagina" fluid>
  <!-- <v-container  fluid> -->
    <div class="text-center ml-4 mr-4 mb-4">
      <!-- {{tiempo_horno_en_marcha}}
      {{tiempo_horno_pausado}} -->
      Tratamiento cargado: <u @click="click_enlace()" :style="estilo_enlace">{{texto_tratamiento}}</u> 
    </div>
    <hr>
    
    <!--  trampa para desarrollo -->
      <!-- <v-row class="text-center">
        <v-col class="ml-4" cols="4">
          <v-text-field v-model="temperaturaActual" 
            label="Temperatura actual">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="mt-3 text-left">
          <v-btn @click="enviarSimulacion()"> Enviar
          </v-btn>
        </v-col>
      </v-row> -->
      <!-- Botones para controlar horno -->
      <v-row class=" ml-3 mt-4 text-center" v-if="estado_horno == 1 || estado_horno == 5 || estado_horno == 6"> <!-- parado o sin receta-->
        <col cols="1" class="text-center mb-3">
         <dialogo-popup></dialogo-popup>
        </col>
        <v-col cols="11" class="text-center mb-3">
          <v-btn v-if="estado_horno == 1 || estado_horno == 6" :disabled="(Object.keys(this.trabajoCargado).length == 0) || estado_horno == 6" :style="'width:100%;'" 
          :dark="(Object.keys(this.trabajoCargado).length > 0) && estado_horno == 1" color="green" @click="dialogo_arrancar = true">Marcha</v-btn>
          <v-btn v-else :style="'width:100%;'"  color="yellow" @click="parar()">Limpiar datos de tratamiento finalizado</v-btn>
          <!-- <v-btn @click="dialogo_arrancar = true">MARCHAAAAAAA</v-btn> -->
        </v-col>
      </v-row>

      <v-row class="ml-3 mt-4 text-center" v-if="estado_horno == 2 || estado_horno == 4 || estado_horno == 3"> <!-- en marcha o en pausa-->
        <col cols="1" class="text-center mb-3">
          <dialogo-popup></dialogo-popup>
        </col>
        <v-col cols="5" v-if="estado_horno == 3" class="text-center mb-3">
          <v-btn :style="'width:100%'" color="blue" dark @click="reanudar()">Reanudar</v-btn> <!-- en pausa -->
        </v-col>
        <v-col cols="5" v-else class="text-center mb-3">
          <v-btn :style="'width:100%'" color="rgba(254, 170, 62, 1)" @click="pausar()">Pausa</v-btn> <!-- en marcha-->
        </v-col>
        <v-col cols="5" class="text-center mb-3">
          <v-btn  :style="'width:100%'" color="rgba(255, 53, 0, 1)" dark @click="dialogo_parar = true">Parar</v-btn>
        </v-col>
      </v-row>  
      <!-- Fin de cabecera de botones -->
      
      <!-- lalalla {{datos_agua}} -->
      <v-card class="mt-2 mb-2" >
        <v-card-title>
          <v-row>
            <v-col cols="4">
              Inicio de ciclo: {{ inicio_ciclo_formateado?inicio_ciclo_formateado: inicio_ciclo_programado_formateado?'Programado para '+inicio_ciclo_programado_formateado:null}}
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" v-if="Object.keys(trabajoCargado).length > 0">
              Medición: 
              <span v-if="trabajoCargado.estado == 1">Aereo</span>
              <span v-else>Contacto</span>
          </v-col>
          <v-col cols="2" v-if="Object.keys(trabajoCargado).length > 0">
           <span style="color: rgba(24, 147, 2,1)"> Zona 1: {{tiempo_real_zona_1?tiempo_real_zona_1+'ºC':null}}</span>
          </v-col>
          <v-col cols="2" v-if="Object.keys(trabajoCargado).length > 0">
            <span style="color: rgba(255, 175, 0, 1)"> Zona 2: {{tiempo_real_zona_2?tiempo_real_zona_2+'ºC':null}}</span>
          </v-col>
          <v-col cols="2" v-if="Object.keys(trabajoCargado).length > 0">
            <span style="color: rgba(44, 112, 237, 1)"> Agua: {{tiempo_real_zona_agua?tiempo_real_zona_agua+'ºC':null}}</span>
          </v-col>
        </v-row>
      </v-card-title>
      </v-card>
      <!-- fin del tiempo en marcha -->
      <div v-if="isPhone" class="full-height">
            <componente-horno ></componente-horno>
            <!-- <componente-grafica class="mt-6" :visible="Object.keys(trabajoCargado).length > 0" :zonas=" -->
            <componente-grafica class="mt-6" :visible="Object.keys(trabajoCargado).length > 0" :zonas="
              [
                detalles_con_pausas,
                datos_pv_1,
                datos_pv_2,
                datos_agua,
                datos_setpoint,
                datos_pv_1_contacto,
                datos_pv_2_contacto
              ]"
              :medicion="trabajoCargado.estado"
              ></componente-grafica>
      </div >
      <div  v-else>
        <v-row class="full-height">
          <!-- Horno -->
          <v-col cols="12" sm="4"md="4">
            <componente-horno class="full-height-component"></componente-horno>
          </v-col>
          <!-- Gráfica -->
          <v-col cols="12" sm="8" md="8">
            <!-- {{detalles_con_pausas}} -->
            <componente-grafica :visible="Object.keys(trabajoCargado).length > 0" :zonas="
              [
                detalles_con_pausas,
                datos_pv_1,
                datos_pv_2,
                datos_agua,
                datos_setpoint,
                datos_pv_1_contacto,
                datos_pv_2_contacto
              ]"
              :medicion="trabajoCargado.estado"
              :setpointMaximo="setpointMax"
              class="full-height-component" ></componente-grafica>
          </v-col>
        </v-row>
      </div>
    <div>
    </div>
        <!-- Información de tiempos -->
        <componenteInfoPrincipal 
          :tiempo_actual="tiempo_en_marcha" 
          :tiempo_restante="tiempo_restante" 
          :hora_finalizacion="hora_fin_total"/>
            

          <!-- BANNER PARA ALARMAS -->
          <v-banner two-line class="text-center red lighten-1">
            <v-row>
              <v-col cols="11">
             
           <span class="white--text">
              <v-icon
                icon="mdi-alert"
                color="white"
              >
                mdi-alert-outline
              </v-icon>

           {{alarmas_activas.length}} <u  @click="$router.push('/alarmas')"" :style="'cursor: pointer; '">ALARMAS ACTIVAS</u>
          </span>
        </v-col>
        <v-col cols="1">
            <template v-slot:actions="{ dismiss }">
              <v-btn
              text
              color="white"
              @click="dismiss"
            >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
              </v-col>
            </v-row>
          </v-banner>
    <FormularioReceta 
      v-if="modificando_trabajo"
      modo="editar"
      :item_editando="recetaCargadaCopiada"
      :desdeEnlace="true" 
      @close="submit"
      @cancel="cancel"
    ></FormularioReceta>
  </v-container>

  <div class="centered-content" v-if="!datosAntiguosCargados">
      SIN COMUNICACIÓN CON MÁQUINA 
   </div>
 
</div>
</template>

<script>
import moment from "moment-timezone";
import { mapActions, mapState } from "vuex";
import componenteHorno from "@/components/ComponenteHorno.vue";
import componenteGrafica from "@/components/ComponenteGrafica.vue";
import componenteInfoPrincipal from "@/components/componenteInfoPrincipal.vue";
import FormularioReceta from "@/components/crud/formularios/FormularioReceta.vue";
import DialogoConfirmacion from "@/components/modulos/DialogoConfirmacion.vue";
import DialogoPopup from "@/components/modulos/DialogoPopup.vue";
import DialogoPin from "@/components/modulos/DialogoPin.vue";

export default {
  name: "Home",

  components: {
    componenteHorno,
    componenteGrafica,
    componenteInfoPrincipal,
    FormularioReceta,
    DialogoConfirmacion,
    DialogoPopup,
    DialogoPin
  },

  data() {
    return {
      banner:true,
      modificando_trabajo: false,
      temperaturaActual: null,
      marcha: true,
      tiempo_restante_anterior:"00:00:00",
      fecha_fin_anterior:'00:00:00',
      tiempo_en_pausa: 0,
      tiempo_inicio_ciclo: {
        horas: 1,
        minutos: 2,
      },
      elapsedTime: 0,
      timerInterval: "",
      popup: false,
      detalles_con_suma:[],
      dialogo_parar:false,
      dialogo_arrancar:false,
      isPhone:false
    };
  },
  mounted(){
    this.banner = true
      this.checkScreenSize();
      window.addEventListener('resize', this.checkScreenSize);
  },
  computed: {
    ...mapState(["inicio_ciclo","estado_horno","trabajoCargado", "alarmas_activas", "alarmas",
    "datos_agua", "datos_pv_1","datos_pv_2","datos_pv_1_contacto","datos_pv_2_contacto",'datos_setpoint','datosAntiguosCargados','tiempo_horno_en_marcha',
    'tiempo_horno_pausado','inicio_programado','tiempo_real_zona_1','tiempo_real_zona_2','tiempo_real_zona_agua']),
    ...mapState("nodered", ["client", "subscriptions"]),
    // Retornamos el estado actual del reloj (en ejecución o detenido).
    descripcion_alarmas_activas(){
      // let 
      if(this.alarmas.length > 0 && this.alarmas_activas.length > 0 ){
       let descripciones = []
        this.alarmas_activas.forEach(activa => {
          let alarma = this.alarmas.find(e => e.id == activa.id)
          descripciones.push(alarma.descripcion)
        });
        return descripciones
      }else return null
    },
    setpointMax(){
      if(Object.keys(this.trabajoCargado).length > 0){

        let setpointMaximo = this.trabajoCargado.detalles.reduce((maximo, objeto) => {
          return objeto.setpoint > maximo ? objeto.setpoint : maximo;
        }, Number.NEGATIVE_INFINITY);
        return setpointMaximo       
      }
    },
    recetaCargadaCopiada() {
      return JSON.parse(JSON.stringify(this.trabajoCargado));
    },
    enlace() {
      console.log(
        `debe cargar nombre trabajo/${this.trabajoCargado.id_trabajo}.`
      );
      return this.conReceta
        ? `trabajo/${this.trabajoCargado.id_trabajo}`
        : { name: "recetas" };
    },
    estilo_enlace() {
      const sin_receta = "color:red; cursor:pointer;";
      const con_receta = "cursor:pointer";
      return this.conReceta ? con_receta : sin_receta;
    },
    texto_tratamiento() {
      return this.conReceta ? this.trabajoCargado.name : "Ninguno";
    },
    conReceta() {
      return Object.keys(this.trabajoCargado).length > 0;
    },

    inicio() {
      if (this.inicio_ciclo) {
        const hours = this.inicio_ciclo.getHours();
        const minutes = this.inicio_ciclo.getMinutes();
        const seconds = this.inicio_ciclo.getSeconds();

        // Format the time as HH:MM:SS
        const formattedTime = `${this.padZero(hours)}:${this.padZero(
          minutes
        )}:${this.padZero(seconds)}`;

        // Function to pad single-digit numbers with a leading zero
        return formattedTime;
      } else return 0;
    },
    inicio_ciclo_formateado() {
      if (this.inicio_ciclo) {
        return moment(this.inicio_ciclo).format("HH:mm:ss DD/MM/YYYY");
      } else {
        return null;
      }
    },
    inicio_ciclo_programado_formateado() {
      if (this.inicio_programado) {
        return moment(this.inicio_programado).format("HH:mm:ss DD/MM/YYYY");
      } else {
        return null;
      }
    },
    detalles_con_pausas() {
      if (Object.keys(this.trabajoCargado).length > 0 && this.inicio_ciclo) {
        //console.log("Hay trabajo cargada");
        // console.log(this.trabajoCargado.detalles);
        return JSON.parse(JSON.stringify(this.trabajoCargado.detalles));
      }
    },

    // variables para ComponenteInfoPrincipal
    tiempo_en_marcha() {
      if (this.inicio_ciclo && this.tiempo_horno_en_marcha != 0) {
        return this.formatTime(this.tiempo_horno_en_marcha);
      } else return "00:00:00";
    },
    tiempo_restante() {
      if (this.inicio_ciclo && this.detalles_con_pausas) {//si esta funcionando y no esta en pausa
        // Hora de finalizacion a segundos
        const totalSegundos2 =  this.$pasar_a_segundos(this.detalles_con_pausas[this.detalles_con_pausas.length - 1].hora_fin)
        
        // Calcular la diferencia en segundos
        let diferenciaSegundos = totalSegundos2 - this.tiempo_horno_en_marcha + this.tiempo_horno_pausado

        if(diferenciaSegundos >= 0){
          const horasTotales = Math.floor(diferenciaSegundos / 3600);
          const minutosTotales = Math.floor((diferenciaSegundos % 3600) / 60);
          const segundosTotales = diferenciaSegundos % 60;
          this.tiempo_restante_anterior = `${String(horasTotales).padStart(2, "0")}:${String(minutosTotales).padStart(2, "0")}:${String(segundosTotales).padStart(2, "0")}`
        }
        else this.tiempo_restante_anterior = "00:00:00" 
      }
      else this.tiempo_restante_anterior = "00:00:00"
      return this.tiempo_restante_anterior
    },
    hora_fin_total() {
      if (this.inicio_ciclo && this.detalles_con_pausas) {
        // let hora_sin_pausas = this.$suma_horas(this.inicio, this.detalles_con_pausas[this.detalles_con_pausas.length - 1].hora_fin);
        // return this.$sumar_segundos_a_hora(this.tiempo_horno_pausado, hora_sin_pausas)
        // return ""+this.detalles_con_pausas[this.detalles_con_pausas.length - 1].hora_fin

        //  En formato de HH:mm:ss dd/mm/yyyy
        // if(this.tiempo_restante != '00:00:00'){
          let fin_en_segundos = this.$pasar_a_segundos(this.detalles_con_pausas[this.detalles_con_pausas.length - 1].hora_fin)
          let fin_con_pausas = fin_en_segundos + this.tiempo_horno_pausado
          const fecha_de_fin = new Date(this.inicio_ciclo.getTime() + fin_con_pausas * 1000);
          this.fecha_fin_anterior = moment(fecha_de_fin).format('HH:mm:ss DD/MM/yyyy')
        // }
      } 
      else this.fecha_fin_anterior = "00:00:00";

      return this.fecha_fin_anterior
    },

    clase_pagina(){
      return (!this.datosAntiguosCargados)?'blurry-overlay':'';
    }
  },
  beforeDestroy() {
    // Remove the resize event listener to prevent memory leaks
    window.removeEventListener('resize', this.checkScreenSize);
  },

  methods: {
    ...mapActions("nodered", ["doPublish", "doSubscribe"]),
    ...mapActions(["setInicioCiclo","setEnMarchaCiclo","setPVZona1","setPVZona2","setPVZonaAgua", "setSetpoints", "cambioEstadoDesdeNodered",
    "pushDatosP1","pushDatosP2","pushDatosAgua","pushDatosSetpoint",'setPausaCiclo','setReanudarCiclo','setPararCiclo','setTrabajo','setDatosAntiguosCargados']),
    ...mapActions("api",['putTrabajo','getTrabajo']),
    checkScreenSize() {
      this.isPhone = window.innerWidth <= 600; // Adjust the breakpoint as needed
    },
    async tratar_datos_tratamiento(tratamiento){
      // console.log('tratamiento',tratamiento)
      // this.tiempo_en_pausa = tratamiento.tiempo_en_pausa?tratamiento.tiempo_en_pausa:this.tiempo_en_pausa
      if (Object.keys(tratamiento).length > 0) {
        let fecha = new Date(tratamiento.momento_lectura);
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        let dia = fecha.getDate()
        let nuevos=[false,false,false,false]
        if (tratamiento.zona_1) {
          //let fecha = new Date(tratamiento.zona_1.hora_ultima_lectura);
         
          nuevos[0]= await this.pushDatosP1({y: tratamiento.zona_1.pv, x:`${dia} - ${hours}:${minutes}`})
        }
        if (tratamiento.zona_2) {
          //let fecha = new Date(tratamiento.zona_2.hora_ultima_lectura);
          // const hours = this.padZero(fecha.getHours());
          // const minutes = this.padZero(fecha.getMinutes());
          nuevos[1]= await this.pushDatosP2({y: tratamiento.zona_2.pv, x:`${dia} - ${hours}:${minutes}`})
        }
        if (tratamiento.zona_agua) {
          //let fecha = new Date(tratamiento.zona_agua.hora_ultima_lectura);
          // const hours = this.padZero(fecha.getHours());
          // const minutes = this.padZero(fecha.getMinutes());
          nuevos[2]= await this.pushDatosAgua({y: tratamiento.zona_agua.pv, x:`${dia} - ${hours}:${minutes}`})
        } 
        if (tratamiento.setpoint) {
         
          // const hours = this.padZero(fecha.getHours());
          // const minutes = this.padZero(fecha.getMinutes());
         
          nuevos[3]= await this.pushDatosSetpoint({y: tratamiento.setpoint, x:`${dia} - ${hours}:${minutes}`})
        }
        // console.log('NUEVOS3',nuevos[3])
        const todos = nuevos.every(v=>v==true)
        // console.log('TODOS',todos)


      
      }
    },
    tratar_ciclo_actual(datos){
      // this.tratado_ciclo_actual=true;
      console.log("tratar_ciclo_actual: estos son los datos",datos)
      // let pv_1 = []
      // let pv_2 = []
      // let agua = []
      // let current_setpoints=[]
      datos.zona_1.forEach(detalle => {
        //console.log("detalle",detalle)
        let fecha = new Date(detalle.hora_ultima_lectura)
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        let dia = fecha.getDate()
          this.pushDatosP1({y: detalle.pv, x:`${dia} - ${hours}:${minutes}`})
      });
      datos.zona_2.forEach(detalle => {
        let fecha = new Date(detalle.hora_ultima_lectura)
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        let dia = fecha.getDate()
          this.pushDatosP2({y: detalle.pv, x:`${dia} - ${hours}:${minutes}`})
      });
      datos.zona_agua.forEach(detalle => {
        let fecha = new Date(detalle.hora_ultima_lectura)
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        let dia = fecha.getDate()
          this.pushDatosAgua({y: detalle.pv, x:`${dia} - ${hours}:${minutes}`})
      });
      datos.setpoint.forEach(detalle => {
        //console.log('detalle del setpoint',detalle)
        let fecha = new Date(detalle.hora_ultima_lectura)
        const hours = this.padZero(fecha.getHours());
        const minutes = this.padZero(fecha.getMinutes());
        let dia = fecha.getDate()

        if(detalle.valor != undefined){
          this.pushDatosSetpoint({y: detalle.valor, x:`${dia} - ${hours}:${minutes}`})
        }
      });


    },

    //Modificar trabajo actual
    async submit(datos) {
      await this.putTrabajo(datos);
      const trabajo_raw = await this.getTrabajo(datos.id_trabajo);
      const trabajo = trabajo_raw.data;
      console.group();
      console.groupEnd();
      this.setTrabajo(trabajo);
      console.log(this.trabajoCargado);
      this.modificando_trabajo = false;
      let setpoint_inicial = null
      let last_setpoint=null
      let payload = {}
      let tramos_a_cargar=[]
      
      datos.detalles.forEach((detalle, index) => {
          if(index==0){
            setpoint_inicial=detalle.setpoint
          }
          //Poner tantos puntos como deltaTimes haya en este segmento
          const diferencia_tiempos_minutos = this.$diferencia_tiempos_minutos( detalle.hora_fin,detalle.hora_inicio)*60
          //Calcular pendiete como
          //(y1-y0)/diferencia_tiempos = (setpoint-last_setpoint)/diferencia_tiempos_minutos
          const pendiete_actual = (last_setpoint)? (detalle.setpoint-last_setpoint)/diferencia_tiempos_minutos:0;

          tramos_a_cargar.push({
              setpoint:index ==0?parseFloat(detalle.setpoint):parseFloat(datos.detalles[index-1].setpoint),
              tiempo:diferencia_tiempos_minutos,
              pendiente:pendiete_actual,
              tolerancia_max:detalle.tolerancia_max,
              tolerancia_min:detalle.tolerancia_min
          })
          console.log("ACTUALIACION; ",tramos_a_cargar);

          last_setpoint=detalle.setpoint;
          payload = {setpoint_inicial, tramos: tramos_a_cargar}
      })
      this.doPublish({ topic: process.env.VUE_APP_TOPIC_TRABAJO_MODIFICADO,  payload: JSON.stringify(payload) });
    },
    cancel() {
      this.modificando_trabajo = false;
    },
    click_enlace() {
      if (this.conReceta) {
        //Debe abrir formulario
        this.modificando_trabajo = true;
        
      } else {
        this.$router.push(this.enlace);
      }
    },
    enviarSimulacion() {
      this.doPublish({ topic: "temperatura", payload: this.temperaturaActual });
    },
    enMarcha(timestamp_inicio) {
      this.setEnMarchaCiclo(timestamp_inicio);
      this.dialogo_arrancar = false
    },
    pausar() {
      this.setPausaCiclo(new Date());
    },
    limpiar(){
      this.setPVZona1([])
      this.setPVZona2([])
      this.setPVZonaAgua([])
      this.setSetpoints([])
    },
    parar() {
      console.log("PARANDOOOOOOOOOOOOOO");
      this.setPararCiclo(new Date());
      clearInterval(this.timerInterval);
      this.setPVZona1([])
      this.setPVZona2([])
      this.setPVZonaAgua([])
      this.setSetpoints([])
      this.dialogo_parar = false
    },
    reanudar() {
      this.setReanudarCiclo(new Date());
    },
    // restartCounter() {
    //   // Reset the start time and elapsed time
    //   this.acSetTiempoMarcha(0);

    //   // Clear the existing interval (if any)
    //   clearInterval(this.timerInterval);

    //   // Start a new interval to update the elapsed time every second
    //   this.timerInterval = setInterval(() => {
    //     this.acSetTiempoMarcha(
    //       Math.floor((new Date() - this.inicio_ciclo) / 1000)
    //     );
    //   }, 1000);
    // },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const formattedTime = `${this.padZero(hours)}:${this.padZero(
        minutes
      )}:${this.padZero(seconds % 60)}`;
      return formattedTime;
    },
    padZero(number) {
      return number < 10 ? `0${number}` : number;
    },

    reintentar(){
      // this.doPublish({ topic: "TRAER_CICLO_1", payload: this.temperaturaActual });
      this.doPublish({ topic: process.env.VUE_APP_TOPIC_CICLO_ACTUAL, payload: this.temperaturaActual });
    }
  },
};
</script>
<style>
.full-height {
  height: 55vh;
  /* 90% del viewport height */
}


.full-height-component {
  height: 100%;
  /* Ocupa el 100% de la altura de su contenedor */
  width: 50%;
  /* 50% del ancho del contenedor */
}
.blurry-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(219, 151, 130, 0.733);
  filter: blur(8px);
}


.full-height-component-flexed {
  z-index: 100;
  height: 100vh; /* Ocupa el 100% de la altura de la ventana */
  display: flex;
  align-items: center; /* Centra verticalmente */
  justify-content: center; /* Centra horizontalmente */
}

.centered-content {
  text-align: center;
  color: black;
  /* Otros estilos según tus preferencias */
}
</style>
